import { CanDeactivateFn } from '@angular/router';

import { TimeSheet } from '../time-sheet';

export const timeSheetUnsavedChangesGuard: CanDeactivateFn<TimeSheet> = (component: TimeSheet) => {
  return component.pendingChanges().length !== 0
    ? confirm(
        $localize`:route guard|Confirmation alert safeguard to prevent accidental loss of unsaved data before leaving the time sheet page@@unsavedChangesAlertText:You have unsaved changes. Are you sure you want to leave?`
      )
    : true;
};
